import myzxios from '../utils/myaxios'

export function getNotice(){
    return myzxios({
        url: '/manager/notice/gt-notice',
        method: 'GET'
    })
}

export function getMail() {
    return myzxios({
        url: 'manager/qu-mail',
        method: 'GET'
    })
}